import type { GetUsers } from "@/server-types";

export type SelectableUser = GetUsers["response"]["users"][number];

// Authorizing without an operator permission would only fail later, at the
// point of issuing or opening the archive.
export function canAuthorizeOnPos(user: SelectableUser) {
  return (
    user.taxNumber != null &&
    user.taxNumber.length > 0 &&
    user.showOnPOS &&
    (user.canIssueInvoices || user.canManageInvoices)
  );
}

// The query data can reach us as a non-null object whose `users` list is
// missing (an unexpected 2xx body), so a missing list is treated as "not yet
// known" rather than an empty roster, and is never dereferenced blindly.
export function computeHasNoAuthorizableUsers(
  users: { users?: SelectableUser[] } | null | undefined,
) {
  return users?.users != null && !users.users.some(canAuthorizeOnPos);
}
